import { useContext, useEffect } from "react";
import { HashRouter } from "react-router-dom";
import "../asset/css/App.css";
import Header from "../components/header/header";
import Navigation from "../components/navigation/navigation";
import AppContext from "../Context/AppContext";
import dashboardRoutes from "../routes";
// import Productsubset from "shared-components/src/views/productSubset"

function App() {
  const { IsFromEZOwnHomePage, setIsFromEZOwnHomePage
        ,getHeaderProductJSONData
        ,HeaderProductJson } =
    useContext(AppContext);

  useEffect(() => {
    let IsHomePage = window.location.href.includes("Homepage=true");
    setIsFromEZOwnHomePage(IsHomePage);
    getHeaderProductJSONData();
  }, []);

  return (
    <div>

      <HashRouter forceRefresh={true}>
        {/* <Productsubset /> */}
        {!IsFromEZOwnHomePage ? <Header HeaderProductJson={HeaderProductJson}/> : null}
        <Navigation routes={dashboardRoutes} />
      </HashRouter>
    </div>
  );
}

export default App;
